/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var VectorLayer = __ol.layer.Vector;
var props = {
  updateWhileAnimating: Boolean,
  updateWhileInteracting: Boolean
  // todo implement options
  // renderOrder: Function,
  // renderBuffer: Number
};

var methods = {
  /**
   * @return {ol.layer.Vector}
   * @protected
   */
  createLayer: function createLayer() {
    return new VectorLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      preload: this.preload,
      extent: this.extent ? core.projHelper.extentFromLonLat(this.extent, this.$view.getProjection()) : undefined,
      zIndex: this.zIndex,
      updateWhileAnimating: this.updateWhileAnimating,
      updateWhileInteracting: this.updateWhileInteracting,
      source: this._source
    });
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    return core.mergeDescriptors(core.layer.methods.getServices.call(this), core.stylesContainer.methods.getServices.call(this));
  },

  /**
   * @return {ol.layer.Vector|undefined}
   * @protected
   */
  getStyleTarget: function getStyleTarget() {
    return this.$layer;
  }
};

var Layer = {
  name: 'vl-layer-vector',
  mixins: [core.layer, core.stylesContainer],
  props: props,
  methods: methods
};

var index = {
  Layer: Layer,
  install: function install(Vue) {
    Vue.component(Layer.name, Layer);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/vector-layer/index.js
// module id = 1202
// module chunks = 1